import {ASSOC_GROUP, DISASTER_TOPIC_CATEGORY, YES_OR_NOT} from '../../../../CodeMaster'
import moment, {Moment} from 'moment'

export class NatDisasterHelper {
    static getTopicCreator(updaterRoleId: string): string {
        if (updaterRoleId === null) {
            return '標準トピック'
        }

        const assocGroupValues = ASSOC_GROUP.values().map(assoc => assoc.value)
        if (assocGroupValues.includes(updaterRoleId)) {
            return '管理組合より'
        }
        return '管理会社より'
    }

    static getTopicCategoryLabel(categoryId: string): string {
        return DISASTER_TOPIC_CATEGORY.codeToEnumConstants(categoryId).label
    }

    static getPostDatetime(currentDatetime: Moment, postDatetime: Moment): string {
        const dateOneWeekAgo = currentDatetime.clone().subtract(7, 'days')

        if (dateOneWeekAgo.isSameOrBefore(postDatetime)) {
            return moment(postDatetime!).fromNow()
        } else {
            return this.formatDoNotDisplayCurrentYear(currentDatetime, postDatetime)
        }
    }

    static formatDoNotDisplayCurrentYear(currentDatetime: Moment, postDatetime: Moment): string {
        if (currentDatetime.year() === postDatetime.year()) {
            return postDatetime.format('MM/DD HH:mm')
        } else {
            return postDatetime.format('YYYY/MM/DD HH:mm')
        }
    }

    static getDeleteMessage(deleterRoleId: string, isDeleterSelf: string): string {
        if (isDeleterSelf === YES_OR_NOT.YES.value) {
            return 'このコメントは削除されました。'
        }

        const assocGroupValues = ASSOC_GROUP.values().map(assoc => assoc.value)
        if (assocGroupValues.includes(deleterRoleId)) {
            return 'このコメントは管理組合によって削除されました。'
        }
        return 'このコメントは管理会社によって削除されました。'
    }
}